import React, { createContext } from 'react'
import useAccountView from '../hooks/useAccountView'

export const AccountViewContext = createContext()

export function AccountViewProvider({ children }) {
  const accountViewHookReturnProps = useAccountView()
  return <AccountViewContext.Provider value={accountViewHookReturnProps}>{children}</AccountViewContext.Provider>
}
